import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import RoutesGridLayout from './containers/Grid';

export default function RouteLayout() {
  return <Router>
    <PrivateRoute path="/cms/settings/routes" component={RoutesGridLayout} />
  </Router>;
}

